import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { CheckPointInfosManagement } from '../components/CheckPointInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TCheckPointSchema,
  checkPointSchema,
} from '@/schemas/check-point/check-point.schema';
import { useCreateCheckPoint } from '@/hooks/check-point.hooks';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '@/utils/language.utils';

export const CreateCheckPointPage = () => {
  const { t } = useTranslation('checkPoint');
  const navigate = useNavigate();

  const {
    watch: watchCheckPoint,
    control: checkPointControl,
    register: registerCheckPoint,
    setValue: setCheckPointValue,
    setError: setCheckPointError,
    handleSubmit: handleSubmitCheckPoint,
    formState: {
      errors: checkPointErrors,
      isSubmitting: isSubmittingCheckPoint,
    },
  } = useForm<TCheckPointSchema>({
    resolver: zodResolver(checkPointSchema),
  });

  const {
    mutate: mutateCreateCheckPoint,
    isPending: isPendingCreateCheckPoint,
  } = useCreateCheckPoint({
    t,
    handleSuccess: () => navigate('/check-points'),
  });

  const onSubmitCheckPoint = (checkPoint: TCheckPointSchema) => {
    const { languageCode } = getLanguage();

    const dataWithLanguageCode = {
      ...checkPoint,
      languageCode,
    };

    mutateCreateCheckPoint(dataWithLanguageCode);
  };

  return (
    <>
      <PageHeader
        backToLink="/check-points"
        title={t('checkPoint')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem text={t('checkPointList')} linkTo="/check-points" />
            <BreadcrumbItem text={t('checkPoint')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <CheckPointInfosManagement<TCheckPointSchema>
          t={t}
          watch={watchCheckPoint}
          control={checkPointControl}
          register={registerCheckPoint}
          setValue={setCheckPointValue}
          setError={setCheckPointError}
          errors={checkPointErrors}
          submitDisabled={isSubmittingCheckPoint || isPendingCreateCheckPoint}
          onSubmit={handleSubmitCheckPoint(onSubmitCheckPoint)}
        />
      </div>
    </>
  );
};
